module.exports = __webpack_public_path__ + "static/media/close-button-danger.d4fa8a3b.png";